import { FC } from 'react';

import { Badge, Link, Tooltip } from '@dbt-labs/sourdough';

import { CostInsightsConnectionTestStatusOverview } from '../typings/costInsights';
import { getConnectionTestBadgeConfig } from '../util/costInsights';

export const PENDING_TOOLTIP_CONTENT =
  'Cost is calculated daily. Please check back tomorrow.';

export const SUCCESS_TOOLTIP_CONTENT =
  'This indicates when the latest update was successfully triggered. Data typically finishes refreshing within ten minutes.';

export interface CostInsightsConnectionBadgeProps {
  statusOverview: CostInsightsConnectionTestStatusOverview;
  connectionSettingsUrl?: string;
  testId?: string;
  linkTestId?: string;
  tooltipContent?: React.ReactNode;
  isCostProcessed?: boolean;
}

export const CostInsightsConnectionBadge: FC<CostInsightsConnectionBadgeProps> = ({
  statusOverview,
  connectionSettingsUrl,
  testId,
  linkTestId,
  tooltipContent,
  isCostProcessed,
}) => {
  if (statusOverview.status === 'never_triggered') {
    return null;
  }

  const badgeProps = getConnectionTestBadgeConfig(statusOverview, { isCostProcessed });

  const badge = <Badge testId={testId} {...badgeProps} />;

  const wrappedBadge = tooltipContent ? (
    <Tooltip content={tooltipContent}>{badge}</Tooltip>
  ) : (
    badge
  );

  if (connectionSettingsUrl && statusOverview.status === 'failed') {
    return (
      <Link isInternal to={connectionSettingsUrl} testId={linkTestId}>
        {wrappedBadge}
      </Link>
    );
  }

  return wrappedBadge;
};
